enum ActionTypes {
  FETCH_APPS_REQUEST = '[App] Fetch Apps Request',
  FETCH_APPS_SUCCESS = '[App] Fetch Apps Success',
  FETCH_APPS_FAIL = '[App] Fetch Apps Fail',
  FETCH_MENU_ITEMS_REQUEST = '[App] Fetch Menu Items Request',
  FETCH_MENU_ITEMS_SUCCESS = '[App] Fetch Menu Items Success',
  FETCH_MENU_ITEMS_FAIL = '[App] Fetch Menu Items Fail',
  MENU_ITEMS_CHANGED = '[App] Fetch Menu Items Changed',
  FETCH_ME_REQUEST = '[App] Fetch Me Request',
  FETCH_ME_SUCCESS = '[App] Fetch Me Success',
  FETCH_ME_FAIL = '[App] Fetch Me Fail',
  FETCH_QUICKSIGHT_DASHBOARD_REQUEST = '[App] Fetch QuickSight Dashboard Request',
  FETCH_QUICKSIGHT_DASHBOARD_SUCCESS = '[App] Fetch QuickSight Dashboard Success',
  FETCH_QUICKSIGHT_DASHBOARD_FAIL = '[App] Fetch QuickSight Dashboard Fail',
}

interface IAction {
  type: ActionTypes;
  payload?: any;
}

const initialState = {
  isLoading: false,
  error: null,
  apps: [],
  me: null,
  settings: {
    name: 'loading',
    themeColor: '#FFFFFF',
    dateFormat: 'dd/MM/yyyy',
    timeFormat: 'h:mm a',
  },
  menuItems: [],
  environmentType: undefined,
  selectedApp: undefined,
  isLoadingDashboard: false,
  dashboardEmbedUrl: undefined,
  dashboardAdapter: undefined,
};

const reducer = (state: any, action: IAction): any => {
  switch (action.type) {
    case ActionTypes.FETCH_APPS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case ActionTypes.FETCH_APPS_SUCCESS: {
      return {
        ...state,
        apps: [
          ...action.payload.apps,
          ...[
            {
              id: 999,
              key: 'report',
              icon: 'fa fa-analytics',
              menu: [],
              name: 'Reports',
            },
          ],
        ],
        settings: {
          ...state.settings,
          ...action.payload.settings,
        },
        environmentType: action.payload.environmentType,
        isLoading: false,
        version: action.payload.version,
        creds: action.payload.creds,
      };
    }

    case ActionTypes.FETCH_APPS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.message || action.payload.messages,
      };

    case ActionTypes.FETCH_MENU_ITEMS_REQUEST:
      return {
        ...state,
        isLoading: true,
        selectedApp: action.payload,
        menuItems: [],
      };

    case ActionTypes.MENU_ITEMS_CHANGED:
    case ActionTypes.FETCH_MENU_ITEMS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        menuItems: action.payload.menuItems,
        selectedApp: action.payload.selectedApp,
      };

    case ActionTypes.FETCH_MENU_ITEMS_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.message || action.payload.messages,
      };

    case ActionTypes.FETCH_ME_REQUEST:
      return {
        ...state,
        isLoading: true,
      };

    case ActionTypes.FETCH_ME_SUCCESS: {
      return {
        ...state,
        me: {
          ...action.payload,
          isAdmin: action.payload.security_role.is_administrator,
        },
      };
    }

    case ActionTypes.FETCH_ME_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.message,
      };

    case ActionTypes.FETCH_QUICKSIGHT_DASHBOARD_REQUEST:
      return {
        ...state,
        isLoadingDashboard: true,
        dashboardEmbedUrl: undefined,
        dashboardAdapter: undefined,
      };

    case ActionTypes.FETCH_QUICKSIGHT_DASHBOARD_SUCCESS: {
      return {
        ...state,
        isLoadingDashboard: false,
        dashboardEmbedUrl: action.payload.embedUrl,
        dashboardAdapter: action.payload.dashboardAdapter,
      };
    }

    case ActionTypes.FETCH_QUICKSIGHT_DASHBOARD_FAIL:
      return {
        ...state,
        isLoadingDashboard: false,
        dashboardEmbedUrl: null,
        dashboardAdapter: null,
        error: action.payload.message,
      };

    default:
      throw new Error();
  }
};

export { initialState, ActionTypes };

export default reducer;
